import { Fragment } from "react";
import { t } from "@/i18n-js/instance";
import { isIgnoredFeature } from "@circle-react/helpers/plansHelpers";
import { FeatureCell } from "./FeatureCell";
import { PlanFeature } from "./FeatureFlag";
import { usePlans } from "./PlansContext";
import { StringFeature } from "./StringFeature";

interface FeatureFlagsProps {
  featureFlagKeys: string[];
}

export const FeatureFlags = ({ featureFlagKeys }: FeatureFlagsProps) => {
  const { plans } = usePlans();

  return (
    <>
      {featureFlagKeys.map(feature => {
        if (isIgnoredFeature(feature)) return null;

        return (
          <Fragment key={feature}>
            <FeatureCell>
              <StringFeature
                hideCheckIcon
                value={t(`pricing_plans.feature.${feature}`)}
                className="pr-5"
              />
            </FeatureCell>
            {plans.map(plan => (
              <PlanFeature key={plan.id} plan={plan} feature={feature} />
            ))}
          </Fragment>
        );
      })}
    </>
  );
};
